import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { closeConfirmToggle } from "../../store/reducers/plantels/plantels.reducer";
import {
  getPlantelsThunk,
  togglePlantelActiveThunk,
} from "../../store/reducers/plantels/plantels.thunks";
import Loader from "../UI/Loader";
import Modal from "../UI/Modal";

const ConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, togglePlantelId, toggling, list } = useSelector(
    (state) => state.plantels,
  );

  const plantel = list.find((p) => p.id === togglePlantelId);

  const handleClose = () => {
    if (!toggling) {
      dispatch(closeConfirmToggle());
    }
  };

  const handleConfirm = async () => {
    const result = await dispatch(togglePlantelActiveThunk(togglePlantelId));
    if (result.meta.requestStatus === "fulfilled") {
      await dispatch(getPlantelsThunk({ page: 1 }));
      handleClose();
    }
  };

  if (!plantel) return null;

  return (
    <Modal
      open={confirmModalOpen}
      title={plantel.is_active ? "Desactivar Plantel" : "Activar Plantel"}
      size="md"
      onClose={handleClose}
    >
      <div className="text-center py-3">
        <Icon
          icon={plantel.is_active ? "mdi:alert-circle" : "mdi:check-circle"}
          width="64"
          height="64"
          className={`mb-3 ${plantel.is_active ? "text-warning" : "text-success"}`}
        />
        <h5 className="mb-3">
          {plantel.is_active
            ? "¿Estás seguro de desactivar este plantel?"
            : "¿Estás seguro de activar este plantel?"}
        </h5>
        <p className="text-muted mb-0">
          Plantel:{" "}
          <span className="fw-medium text-dark">{plantel.nombre}</span>
        </p>
        <p className="text-muted">
          Clave: <code>{plantel.clave}</code>
        </p>
      </div>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClose}
          disabled={toggling}
        >
          Cancelar
        </button>
        <button
          type="button"
          className={`btn ${plantel.is_active ? "btn-danger" : "btn-success"} d-flex align-items-center gap-2`}
          onClick={handleConfirm}
          disabled={toggling}
        >
          {toggling ? (
            <>
              <Loader type="spinner" size="sm" delay={0} />
              Procesando...
            </>
          ) : (
            <>
              <Icon
                icon={plantel.is_active ? "mdi:close-circle" : "mdi:check-circle"}
                width="20"
                height="20"
              />
              {plantel.is_active ? "Desactivar" : "Activar"}
            </>
          )}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmToggleModal;
